import React from 'react';
import { useTranslation } from 'react-i18next';
import { Workflow, ClipboardList, Settings2, Users, FileCheck2 } from 'lucide-react';

const STEPS = [
  { n: '01', icon: ClipboardList, color: '#176A70' },
  { n: '02', icon: Settings2, color: '#0D9488' },
  { n: '03', icon: Users, color: '#D97706' },
  { n: '04', icon: FileCheck2, color: '#7C3AED' },
];

export default function HowItWorks() {
  const { t } = useTranslation();
  const L = (k) => t(`pages.landing2.flow.${k}`);
  return (
    <section className="max-w-7xl mx-auto px-6 py-20 lg:py-24" data-testid="how-it-works-section">
      <div className="max-w-3xl mb-12">
        <span className="inline-flex items-center gap-2 rounded-full bg-cyan-50 border border-cyan-100 px-4 py-1.5 text-xs font-semibold text-cyan-700">
          <Workflow className="h-3.5 w-3.5" /> {L('eyebrow')}
        </span>
        <h2 className="mt-5 text-3xl sm:text-4xl font-extrabold tracking-tight">{L('heading')}</h2>
        <p className="mt-4 text-slate-600 md:text-lg">{L('sub')}</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={s.n} className="rounded-2xl bg-white border border-slate-200 p-6 relative" style={{ borderTop: `3px solid ${s.color}` }} data-testid={`flow-step-${i + 1}`}>
              <div className="flex items-center justify-between mb-4">
                <div className="h-10 w-10 rounded-xl grid place-items-center" style={{ background: `${s.color}12` }}>
                  <Icon className="h-5 w-5" style={{ color: s.color }} />
                </div>
                <span className="text-2xl font-extrabold tabular-nums" style={{ color: `${s.color}40` }}>{s.n}</span>
              </div>
              <h3 className="font-bold">{L(`s${i + 1}t`)}</h3>
              <p className="text-sm text-slate-500 leading-relaxed mt-2">{L(`s${i + 1}d`)}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
}
